/**
 * UPLOAD-WIRE A — browser-side gzip for the upload wire.
 *
 * XER is tab-separated text (~8-10× gzip). Railway's edge closes any request
 * after 5 minutes; compressing on the wire is what lets a ~200 MB schedule
 * cross in time on a normal uplink. Streamed via CompressionStream (bounded
 * memory, UI stays responsive); files ≤ the threshold — or browsers without
 * CompressionStream (pre-Safari 16.4 / Firefox 113) — send exactly as today.
 *
 * @module dashboard/utils/wireCompress
 */

export const GZIP_THRESHOLD_BYTES = 2 * 1024 * 1024; // 2 MiB

/** True when this file should be gzipped for the wire. */
export function canWireGzip(file) {
  return typeof CompressionStream === 'function'
    && !!file
    && typeof file.stream === 'function'
    && file.size > GZIP_THRESHOLD_BYTES;
}

/**
 * Stream-compress a File into a Blob for the same multipart field.
 * @param {File} file
 * @returns {Promise<{blob: Blob, name: string}>} `${original}.gz`
 */
export async function gzipFileForWire(file) {
  const compressed = file.stream().pipeThrough(new CompressionStream('gzip'));
  const blob = await new Response(compressed).blob();
  return { blob, name: `${file.name}.gz` };
}
